const FORMATTER = new Intl.NumberFormat('nl-NL')

/** 2.850 — the thousands separator from the design. */
export function formatNumber(value: number): string {
  return FORMATTER.format(value)
}
